import React from "react";
import PageHeader from "@/components/PageHeader";
import { ProfileCard } from "@/components/settings/ProfileCard";
import { BrandingCard } from "@/components/settings/BrandingCard";
import { NotificationsCard } from "@/components/settings/NotificationsCard";
import { SubscriptionCard } from "@/components/settings/SubscriptionCard";
import { IdentityCard, NonCustodialCard } from "@/components/settings/IdentityCards";
import { DangerZoneCard } from "@/components/settings/DangerZoneCard";

const Settings = () => (
  <div data-testid="settings-page">
    <PageHeader
      overline="Account"
      title="Settings"
      description="Manage your profile, branding, wallet, and notifications."
    />

    <div className="p-4 md:p-8 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
      <div className="md:col-span-7 space-y-6 md:space-y-8 min-w-0">
        <ProfileCard />
        <BrandingCard />
        <NotificationsCard />
      </div>

      <section className="md:col-span-5 space-y-6 min-w-0">
        <IdentityCard />
        <SubscriptionCard />
        <NonCustodialCard />
        <DangerZoneCard />
      </section>
    </div>
  </div>
);

export default Settings;
